module.exports = __webpack_public_path__ + "img/Size=20, Style=light.f8de639d.svg";